import { isDebug } from './env'
import history from '@/router'
export const PARAM_SESSION_USER = 'x-session-user'
export const PARAM_SESSION_KEY = 'x-session-key'
export const PARAM_USER_AGENT = 'X-BXL-User-Agent'

export const PARAM_USER_NAME = 'userName'
export const PARAM_USER_INFO = 'userMsg'
export const PARAM_USER_ROLE = 'userRole'

let envSuffix = isDebug() ? '_dogfood' : '_lego'

export interface IUserSession {
  userId?: string | null
  sessionKey?: string | null
}

export interface IUserRole {
  capabilities: string[] | null | undefined
}

export function setEnv(isDogfood: boolean) {
  if (isDogfood) {
    envSuffix = '_dogfood'
  } else {
    envSuffix = ''
  }
}

function keyOf(key: string): string {
  return key + envSuffix
}

function clearUserInfo() {
  try {
    localStorage.removeItem(keyOf(PARAM_USER_INFO))
    localStorage.removeItem(keyOf(PARAM_USER_NAME))
    localStorage.removeItem(keyOf(PARAM_USER_ROLE))
  } catch (e) {
    console.error(e)
  }
}

function setUserInfo(userId: string | undefined | null, sessionKey: string | undefined | null) {
  try {
    if (!userId || !sessionKey) return
    localStorage.setItem(
      keyOf(PARAM_USER_INFO),
      JSON.stringify({
        userId,
        sessionKey,
      })
    )
  } catch (e) {
    console.error(e)
  }
}

function getUserInfo(): IUserSession | null | undefined {
  const rawInfo = localStorage.getItem(keyOf(PARAM_USER_INFO))
  if (rawInfo && rawInfo !== 'undefined' && rawInfo !== 'null') {
    try {
      return JSON.parse(rawInfo)
    } catch (e) {
      console.error(e)
    }
  }
  return null
}

function getUserId(): string {
  const info = getUserInfo()
  if (!info) return ''
  return info.userId || ''
}

function isSigned(): boolean {
  const info = getUserInfo()
  console.warn(info)
  return info && info.userId && info.sessionKey ? true : false
}

function setUserName(username: string) {
  try {
    if (!username) return
    localStorage.setItem(keyOf(PARAM_USER_NAME), username)
  } catch (e) {
    console.error(e)
  }
}

function getUserName(): string | null | undefined {
  try {
    return localStorage.getItem(keyOf(PARAM_USER_NAME))
  } catch (e) {
    console.error(e)
  }
  return null
}

function setRole(r: any) {
  if (r && Array.isArray(r.capabilities)) {
    try {
      localStorage.setItem(keyOf(PARAM_USER_ROLE), JSON.stringify(r))
    } catch (e) {
      console.error(e)
    }
  }
}

function getRole(): IUserRole | null | undefined {
  try {
    const rs = localStorage.getItem(keyOf(PARAM_USER_ROLE))
    if (!rs) return undefined
    return JSON.parse(rs)
  } catch (e) {
    console.error(e)
  }
  return null
}

export {
  setUserInfo,
  getUserInfo,
  isSigned,
  getUserName,
  getUserId,
  clearUserInfo,
  setUserName,
  setRole,
  getRole,
}

export function getAuthHeaders() {
  const userInfo = getUserInfo()
  return {
    [PARAM_SESSION_USER]: userInfo?.userId || '',
    [PARAM_SESSION_KEY]: userInfo?.sessionKey || '',
    [PARAM_USER_AGENT]: 'channel_lego',
  }
}

export const signOut = () => {
  clearUserInfo()
  const { pathname, state, search } = history.location
  history.replace({
    pathname: '/login',
    search: pathname.startsWith('/login')
      ? search
      : `?redirect=${encodeURIComponent(pathname + search)}`,
    state,
  })
}
